import formatterValToPercentage from "./plugins/formatterValToPercentage.js"

export default {
  mixins: [formatterValToPercentage]
}
